<template>
  <v-stepper
    v-model="currentStep"
    class="mx-auto ml-md-auto mr-md-0"
    flat
    width="100%"
    min-width="300"
    max-width="355"
    color="transparent"
    :alt-labels="true"
  >
    <v-stepper-header>
      <v-stepper-step color="transparent" step="STEP1" class="px-0 d-flex flex-column text-caption step-customized">
          入力
      </v-stepper-step>
      <v-stepper-step color="transparent" step="STEP2" class="px-0 d-flex flex-column text-caption step-customized">
        入力内容<span class="pt-1">確認</span>
      </v-stepper-step>
      <v-stepper-step color="transparent" step="STEP3" class="px-0 d-flex flex-column text-caption step-customized">
        認証コード<span class="pt-1">確認</span>
      </v-stepper-step>
      <v-stepper-step color="transparent" step="STEP4" class="px-0 d-flex flex-column text-caption step-customized">
        集荷受付<span class="pt-1">完了</span>
      </v-stepper-step>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
    name: "entry-steps",
    props: {
        currentStep: null,
    }
}
</script>

<style lang="scss" scoped>
::v-deep {
    .v-stepper__header {
      box-shadow: unset !important;
    }
    .step-customized {
        flex-basis: 60px !important;
        &.v-stepper {
            &__step {
                &--active {
                    .v-stepper__step__step {
                        color: #009098 !important;
                        font-weight: bold;
                    }
                    .v-stepper__label {
                        background-color: #009098;
                        color: #FFF;
                        position: relative;
                        &:after {
                            content: "";
                            display: block;
                            position: absolute;
                            top: 0;
                            bottom: 0;
                            right: -22%;
                            margin: auto;
                            width: 4px;
                            height: 4px;
                            border-top: 1px solid #009098;
                            border-right: 1px solid #009098;
                            -webkit-transform: rotate(45deg);
                            transform: rotate(45deg);
                        }
                    }
                }
            }
        }
    }
    .v-stepper__step__step {
        background-color: transparent !important;
        color: #CACACA !important;
        margin-bottom: 0 !important;
    }
    .v-stepper__label {
        display: flex !important;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        max-width: 76px;
        width: 100%;
        min-height: 40px;
        border: 1px solid #EAEAEA;
        border-radius: 4px;
        text-shadow: unset !important;
        white-space: nowrap;
        padding: 4px 8px;
    }
}

@media screen and (max-width: 374px) {
.v-stepper {
    &__label {
        font-size: 10px !important;
        padding: 4px 8px;
    }
}
::v-deep {
    .v-stepper__step--active {
        .v-stepper__label {
            &:after {
                right: -12% !important;
            }
        }
    }
}

}
</style>